import { Backdrop, Box, Button, Typography } from "@mui/material";
import TopBar from "../../../Layout/components/TopBar/TopBar";
import styles from "./CreateFaqArticle.module.scss";
import "react-quill/dist/quill.snow.css";
import HeiTextField from "../../../Common/components/Form/HeiTextField/HeiTextField";
import useCreateFaq from "../hooks/useCreateFaq";
import { useNavigate } from "react-router-dom";
import HeiSelection from "../../../Common/components/HeiSelection/HeiSelection";
import { faqToolOptions } from "../../../Common/consts/faqToolOptions";
import { useSelector } from "react-redux";
import { selectHeiUser } from "../../../Auth/store/accountSlice";
import { useMemo } from "react";
import usePageTitle from "../../../Common/hooks/usePageTitle";
import HeiDatePicker from "../../../Common/components/Form/HeiDatePicker/HeiDatePicker";
import dayjs from "dayjs";
import HeiRadioGroup from "../../../Common/components/Form/HeiRadioGroup/HeiRadioGroup";
import { publicationModeOptions } from "../../Common/models/FaqArticle";

const CreateFaqArticle = (): JSX.Element => {
  usePageTitle("FAQ | Create");
  const navigate = useNavigate();
  const heiUser = useSelector(selectHeiUser);

  const isAdmin = useMemo(
    () => heiUser.roles.some((r) => r === "Admin"),
    [heiUser]
  );
  const { form, submit, isLoading } = useCreateFaq();
  const { control, getValues } = form;
  const currentDate = dayjs();

  if (!isAdmin) return <></>;

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      ></Backdrop>
      <TopBar>
        <Box>
          <Typography variant="h4">Create article</Typography>
        </Box>
      </TopBar>
      <div className={styles.createFaqView}>
        <HeiTextField
          name={"title"}
          label="Title"
          control={control}
          rules={{
            required: "Title is required",
          }}
        />
        <HeiTextField
          name={"synopsis"}
          label="Synopsis"
          control={control}
          rules={{
            required: "Synopsis is required",
          }}
        />
        <HeiSelection
          options={faqToolOptions.map((f) => f.toolName)}
          getValues={getValues}
          fieldName={"tools"}
          label="Tools"
          multiple
          control={control}
        />
        <HeiTextField
          name={"alertTitle"}
          label="Alert title"
          control={control}
        />
        <HeiTextField name={"alertBody"} label="Alert body" control={control} />
        <HeiRadioGroup
          label="Publication mode"
          control={control}
          options={publicationModeOptions()}
          name={`publicationMode`}
          rules={{
            required: "Publication mode is required",
          }}
        />
        <HeiDatePicker
          name={"publicationDate"}
          label="Publication date"
          minDate={currentDate}
          control={control}
          rules={{
            required: "Publication date is required",
          }}
        />
        <HeiDatePicker
          name={"endDate"}
          label="End date"
          minDate={currentDate}
          control={control}
        />
        <HeiTextField
          name={"pageId"}
          label="Confluence Page ID"
          control={control}
          placeholder="Enter Confluence page ID (e.g. 64398225)"
          rules={{
            required: "Confluence Page ID is required",
          }}
        />
        <div className={styles.actionButtons}>
          <Button onClick={() => submit()} variant="contained">
            Create
          </Button>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
        </div>
      </div>
    </>
  );
};

export default CreateFaqArticle;
